import React, { Component } from 'react';
import { connect } from 'react-redux';
import { UserOutlined, WhatsAppOutlined } from '@ant-design/icons';
import { Dropdown, Avatar, Button, Menu } from 'antd';
import { withTranslation } from 'react-i18next';
import Link from 'next/link';
import { getUserInitials } from '../../Utils/userUtils';
import { userSignOut, getBranch } from '../../actions';
import { getRolename } from '../../lib/AuthUtils'
import ReactGA from "react-ga4";

class UserBar extends Component {
  constructor(props) {
    super(props);

    const { auth } = this.props;
    const roleName = getRolename(auth)

    this.state = {
      roleName,
      // showWhatsApp: !!((roleName === 'cliente' || roleName === 'vendedor')),
      showWhatsApp: false,
    }
  }

  componentDidMount() {
    const { user } = this.props;
    const { showWhatsApp, roleName } = this.state;

    const branchId = roleName === 'cliente' ? user.sucursalId : roleName === 'vendedor' ? user.vendedor.sucursalId : null;

    if (showWhatsApp) {
      this.props.getBranch(branchId);
    }
  }

  handleMenuClick = e => {
    switch (e.key) {
      case "logout":
        this.props.userSignOut();
        break;

      default:
        break;
    }
  }

  render() {
    const { user, branch, t } = this.props;
    const { showWhatsApp } = this.state;
    const username = user ? user.username : "";
    const userInitials = getUserInitials(user);
    const avatarColor = localStorage.getItem('avatarColor') || '#f56a00';

    const WHATSAPP_MESSAGE = encodeURIComponent(t('whatsapp_message'));

    const handleWhatsAppClick = (contactName, phoneNumber, event) => {
      event.preventDefault();

      const event_params = {
        eventCategory: "WhatsApp Link Clicked",
        eventLabel: "WhatsApp engagement",
        branchName: branch.nombresucursal,
        contactName,
        phoneNumber
      };

      ReactGA.event('startWhatsAppChat', event_params);

      setTimeout(() => {
        window.open(`https://api.whatsapp.com/send/?phone=549${phoneNumber}&text&type=phone_number&app_absent=0&text=${WHATSAPP_MESSAGE}`, '_blank');
      }, 100);
    };

    const userItems = [
      {
        key: 'username',
        label: username,
        type: 'group',
        children: [
          { type: 'divider' },
          {
            key: 'profile',
            label: (
              <Link href={'/profile'}><a>{t('My Profile')}</a></Link>
            )
          },
          { key: 'logout', label: t('Logout') }
        ]
      }
    ];

    const whatsappItems = branch && branch.contactLines
      ? branch.contactLines
        .filter(contact => contact.phoneNumber && contact.contactName)
        .map((contact, index) => ({
          key: index.toString(),
          label: (
            <a href="#" onClick={(e) => handleWhatsAppClick(contact.contactName, contact.phoneNumber, e)} target="_blank" rel="noopener noreferrer">
              {contact.contactName}
            </a>
          ),
        }))
      : [];


    return (
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}>
        {showWhatsApp && (
        <Dropdown overlay={<Menu items={whatsappItems} onClick={this.handleMenuClick} />} trigger={['click']}>
          <Button className="whatsapp-button-custom" icon={<WhatsAppOutlined style={{ fontSize: '32px', color: '#25D366' }} />} />
        </Dropdown>
        )}
        <Dropdown
          overlay={<Menu items={userItems} onClick={this.handleMenuClick} />}
          className="logout-bar hidden-print"
          trigger={['click']}>
          <a className="ant-dropdown-link" href="#">
            {userInitials ?
              <Avatar style={{ backgroundColor: avatarColor, marginLeft: '15px' }}>{userInitials}</Avatar>
              :
              <UserOutlined className="logout-icon" style={{ marginLeft: '15px' }} />
            }
          </a>
        </Dropdown>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  getBranch: (branchId) => {
    dispatch(getBranch(branchId));
  },
  userSignOut: () => {
    dispatch(userSignOut());
  }
});

const mapStateToProps = ({ auth, branches }) => {
  const { user } = auth;
  const { branch } = branches;

  return { auth, user, branch };
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(UserBar));